import { Container, Row, Col} from 'react-bootstrap';
import "./ValueComponent.css"
import localMarket from "../assets/Local-Market.avif"
import strHost from "../assets/andrea-davis-NngNVT74o6s-unsplash.jpg"
import cheers from "../assets/cheers.avif"

const ValueComponent = () => (
    <>
    
    <h2 className="value-header"> Elevated Digital Presence</h2>
    {/* First Section - Text Left, Image Right */}
    <Container>
        <Row className="content-row">
        <Col md={6}>
            <div>
            <h2 className="value-text-subheader">Local Connections</h2>
            <p className="value-text">
                We believe local businesses deserve local attention. Our company was 
                founded with one clear idea: to connect neighborhood favorites like 
                restaurants, coffee shops, salons, boutiques, and bars with short-term rental 
                guests discovering the best of the city for the first time.
            </p>
            </div>
        </Col>
        <Col md={6}>
            <div className="image-content">
            <img 
                src={localMarket} 
                alt="Local restaurant atmosphere" 
            />
            </div>
        </Col>
        </Row>
    </Container>

    {/* Second Section - Image Left, Text Right */}
    <Container>
        <Row className="content-row">
        <Col md={6}>
            <div className="image-content">
            <img 
                src={strHost}
                alt="Short-term rental interior" 
            />
            </div>
        </Col>
        <Col md={6}>
            <div>
            <h2 className="value-text-subheader">Earn Affiliate Income</h2>
            <p className='value-text'>
                STR Host!? Maximize your earnings by partnering with local businesses. 
                Our affiliate program allows short-term rental hosts to recommend nearby services 
                and experiences to their guests, earning commissions on every successful referral.
            </p>
            </div>
        </Col>
        </Row>
    </Container>

    {/* Third Section - Text Left, Image Right */}
    <Container>
        <Row className="content-row">
        <Col md={6}>
            <div>
            <h2 className="value-text-subheader">Elegant First Impressions</h2>
            <p className="value-text">
                HostLink was built by STR Hosts, for STR Hosts. 
                We know exactly how important first impressions are. 
                Stand out from the crowded platforms by elevating your digital presence.
                Create elegant welcome displays, build a brand, 
                increase revenue, and provide unique experiences.
                Install HostLink and leverage ALL of your Real Estate.
            </p>
            </div>
        </Col>
        <Col md={6}>
            <div className="image-content">
            <img 
                src={cheers}
                alt="Red Mercedes sports car" 
            />
            </div>
        </Col>
        </Row>
    </Container>
    </>
);

export default ValueComponent;